export default () => ({});

export const commonStyles = ({
  card: {
    height: 300,
    maxHeight: 'calc(100vh - 240px)',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  title: {
    margin: '1rem 0',
    flex: 1,
  },
  pagination: {
    margin: '1rem auto 2rem',
    display: 'flex',
    justifyContent: 'center',
  },
  assignmentProperty: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
  },
});
